import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

const EventItemHeader = ({ totalSwings, averageSwing, averages, onDelete }) => {
	return (
		<ListItem sx={{ padding: '12px 16px' }}>
			<ListItemText
				primary={"Total Swings: " + totalSwings}
				primaryTypographyProps={{ style: { fontWeight: "bold" } }}
				sx={{ minWidth: '120px', maxWidth: '120px' }}
			/>
			<Box sx={{ display: 'flex', gap: 3, flex: 1, alignItems: 'center' }}>
				<ListItemText
					primary={"Avg Carry: " + averageSwing + " yds"}
					primaryTypographyProps={{ style: { fontWeight: "bold", textAlign: 'center' } }}
					sx={{ minWidth: '140px', textAlign: 'center' }}
				/>
				<ListItemText
					primary={"Avg Launch: " + (averages?.launch ? averages.launch.toFixed(1) + "°" : "N/A")}
					primaryTypographyProps={{ style: { fontWeight: "bold", textAlign: 'center' } }}
					sx={{ minWidth: '120px', textAlign: 'center' }}
				/>
				<ListItemText
					primary={"Avg Ball Speed: " + (averages?.ballSpeed ? averages.ballSpeed.toFixed(1) + " mph" : "N/A")}
					primaryTypographyProps={{ style: { fontWeight: "bold", textAlign: 'center' } }}
					sx={{ minWidth: '150px', textAlign: 'center' }}
				/>
				<ListItemText
					primary={"Avg Spin Rate: " + (averages?.spin ? Math.round(averages.spin) + " rpm" : "N/A")}
					primaryTypographyProps={{ style: { fontWeight: "bold", textAlign: 'center' } }}
					sx={{ minWidth: '150px', textAlign: 'center' }}
				/>
			</Box>
			<IconButton onClick={onDelete} sx={{ minWidth: '48px' }}>
				<DeleteIcon color="error" />
			</IconButton>
		</ListItem>
	);
};

export default EventItemHeader;
